:host {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 3rem;
  align-items: center;
  --aha-empty-state-jumbo--media-placeholder-background: #f1f1f1;
  --aha-empty-state-jumbo--media-height-ratio: 58.16%;
  --aha-empty-state-jumbo--media-shadow: 0;
  --aha-empty-state-jumbo--media-img-fit: contain;
}

:host(.media-shadow) {
  --aha-empty-state-jumbo--media-shadow: 0 3px 15px rgb(0 0 0 / 20%);
}

#media-container {
  background: var(--aha-empty-state-jumbo--media-placeholder-background);
  width: 100%;
  height: 0;
  padding-top: var(--aha-empty-state-jumbo--media-height-ratio);
  box-shadow: var(--aha-empty-state-jumbo--media-shadow);
  position: relative;
}

slot[name='media']::slotted(*) {
  position: absolute;
  top: 0;
  left: 0;
  height: 100% !important;
  width: 100% !important;
}

slot[name='media']::slotted(img) {
  object-fit: var(--aha-empty-state-jumbo--media-img-fit);
}

slot[name='headline']::slotted(*) {
  display: block;
  color: var(--theme-tertiary-text);
  margin-bottom: var(--spacer-1);
  font-size: calc(var(--default-font-size) + 2px);
  line-height: 1;
}

slot[name='title']::slotted(*) {
  display: block;
  color: var(--theme-primary-text);
  margin: 0 0 var(--spacer-4) 0;
  font-weight: bold;
  font-size: 2.625rem;
  line-height: 1.4;
}

slot[name='body']::slotted(*) {
  color: var(--theme-primary-text);
  font-size: 1rem;
}
